// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"221e3b27","453":"2d9385bd","464":"c13ab63a"}[chunkId] + ".chunk.js";
};